export const en = {
    commonLabels: {
        courses: `Courses`,
        lessons: `Lessons`,
        chapters: `Chapters`,
        sections: `Sections`,
        course: `Course`,
        lesson: `Lesson`,
        chapter: `Chapter`,
        section: `Section`,
        success: `Success`,
        error: `Error`,
        action: `Action`,
        comment: `Comment`,
        ok: `Ok`,
        confirm: `Confirm`,
        confirmation: `Confirmation`,
        cancel: `Cancel`,
        submit: `Submit`,
        create: `Create`,
        add: `Add`,
        view: `View`,
        edit: `Edit`,
        update: `Update`,
        delete: `Delete`,
        back: `Back`,
        continue: `Continue`,
        save: `Save`,
        upload: `Upload`,
        select: `Select`,
        enter: `Enter`,
        required: `Required`,
        name: `Name`,
        description: `Description`,
        email: `Email`,
        emailId: `Email Id`,
        address: `Address`,
        phone: `Phone`,
        phoneNo: `Phone Number`,
        status: `Status`,
        editor: `Editor`,
        reviewer: `Reviewer`,
        owner: `Owner`,
        owners: `Owners`,
        saveAndContinue: `Save & Continue`,
        basicInformation: `Basic Information`,
        fundamentals: `Fundamentals`,
        courseOutline: `Course outline`,
        knowledgeGoals: `Knowledge Goals`,
        targetAudience: `Target Audience`,
        prerequisites: `Prerequisites`,
        trainingObjectives: `Training Objectives`,
        subjects: `Subjects`,
        useCases: `Use Cases`,
        subject: `Subject`,
        useCase: `Use Case`,
        ekcMatrix: `EKC Matrix`,
        contentDescription: `Content Description`,
        programPlan: `Program Plan`,
        export: `Export`,
        viewData: `View Data`,
        editData: `Edit Data`,
        deleteData: `Delete Data`,
        noRecordsFound: `No Records Found`,
        inactive: `Inactive`,
        loading: `Loading`,
        dontKnowWhereToStart: `Don't know where to start?`,
        overview: `Overview`,
        team: `Team`,
        role: `Role`,
        srNo: `Sr. No`,
        file: `File`,
        files: `Files`,
        value: `Value`,
        moveOnCourseMsg: `You are about to save this programme's basic information and moving forward towards creating courses. In order to ensure a proper setup for the rest of this programme please makes sure that all Basic information have been filled in.`,
        enterNewVersionName: `Enter New Version Name`,
        newVersion: `New Version`,
        pleaseEnterPrompt: `Please enter prompt`,
        areYouSure: `Are you sure?`,
        yes: `Yes`,
        no: `No`,
        wantToContinue: `Do you wanna continue?`,
        duplicateFileValidation: `File with same name already exists in this program: `,
        fileLimit: `You can upload a maximum of 25 files in each program`,
        invalidFile: `Invalid format`,
        versionError: `Version name cannot be empty.`,
        versionUnique: `Version name must be unique.`,
        addLesson: `Add Lesson`,
        editCourse: `Edit Course`,
        deleteCourse: `Delete Course`,
        addChapter: `Add Chapter`,
        editChapter: `Edit Chapter`,
        deleteChapter: `Delete Chapter`,
        editLesson: `Edit Lesson`,
        deleteLesson: `Delete Lesson`,
        addSection: `Add Section`,
        editSection: `Edit Section`,
        deleteSection: `Delete Section`,
        productionDashboard: `Production Dashboard`,
        draftVersionConfirmationMsg: `There is a draft version data available for this. Press 'Yes' to use the saved draft data or 'No' to proceed with the existing/blank data.`,
        maxLengthReached: `Maximum length reached`,
        maxLimitReached: `Maximum limit reached`,
        sessionExpire: `Your session has expired, Please login again.The system has not saved your unsaved data. Kindly re-login to continue your work.`,
        sessioTitle: `Session Timeout`,
        reLogin: `Re-Login`,
        storyboard: `Storyboard`,
        deleteFileConfirmation: `Are you sure want to delete File?`,
        invalidFormat: `Invalid format`,
        closeVersion: `Close Version`,
        confirmDelete: `Confirm Delete`,
        selectCourses: `Select Courses`,
        includeResource: `Do not include resources`,
        selectCourse: `Please Select Courses`,
        selected: `selected`,
        use: 'Use',
        assist: `assist`,
        sectionTitle: `Section Headline`,
        script: `Script`,
        presentation: `Presentation`,
        notes: `Directional notes`,
        resources: `Resources`,
    },
    otpLabels: {
        enterOtp: `Enter OTP`,
        didntReceiveOtp: `Didn't receive the OTP?`,
        clickToResend: `Click to resend`,
    },
    roleSelectionLabels: {
        selectRole: `Select Role`,
        logOut: `Log Out`,
    },
    homePageLabels: {
        home: `Home`,
        homePageDescription: `Here you can see all the Programmes you are a part of. You can sort after preference or create a new programme.`,
        homeReviewerView: `Here you can see all the Programmes you are a part of.`,
        createProgramme: `Create Programme`,
        searchInputPlaceholder: `Program Name,Course Name or Owner Name`,
        selectDateRange: `Select Date Range`,
        sortBy: `Sort By`,
        lastVisited: `Last Visited`,
        sortByAtoZ: `Sort By A-Z`,
        sortByZtoA: `Sort By Z-A`,
        sortByNewestFirst: `Sort By Newest First`,
        sortByOldestFirst: `Sort By Oldest First`,
        newestFirst: `Sort By Newest First`,
        viewInTop: `View from Top`,
        deleteProgramConfirmationMsg1: `Are you sure you want to delete this program`,
        deleteProgramConfirmationMsg2: `This action will archive the program, and it will no longer be visible in the Program Catalog. You can't restore it later if needed`,
        noResultsFound: `No results found`,
        createdOn: `Created on`,
        configureProgram: `Configure Program`,
        productionDashboard: `Production Dashboard`,
        draftVersionMessage: `You have saved draft data available.`,
        downloadFile: `Download file`,
        noCourseAssigned: `No Course assigned, please contact admin.`,
    },
    topBarLabels: {
        home: `Home`,
        overview: `Overview`,
        productionDashboard: `Production Dashboard`,
        team: `Team`,
        members: `Members`,
        knowledgeBank: `Knowledge Bank`,
        accountType: `Account Type`,
        myProfile: `My Profile`,
        logout: `Logout`,
        role: `Role`,
    },
    teamLabels: {
        listOfTeams: `List Of Teams`,
        addTeam: `Add team`,
        searchInputPlaceholder: `Team Name or Description`,
        teamName: `Team name`,
        teamDescription: `Description of Team`,
        numberOfMember: `Number of Member`,
        assignedCourse: `Assigned Course`,
        teamNameIsRequired: `Team Name is required`,
        selectTeamMember: `Select Team Member`,
        assignMember: `Assign Member`,
        assignRole: `Assign Role`,
        selectMember: `Select Member`,
        selectRole: `Select Role`,
        enterTeamDescription: `Enter Team Description`,
        assignTeam: `Assign Team`,
        selectCourse: `Select Course`,
        deleteTeamConfirmationMsg: `Are you sure want to Delete this Team`,
        invalidFormError: `Both user and roles are necessary!`,
        enterTeamName: `Enter Team Name`,
        teamMember: `Team Member`,
        assignCourse: `Assigned Course`,
    },
    membersLabels: {
        importMembers: `Import Members`,
        addMembers: `Add Member`,
        editMembers: `Edit Member`,
        listOfMembers: `List of Members`,
        searchInputPlaceholder: `Name, Email ID or Phone Number`,
        userId: `User ID`,
        organizationName: `Organization Name`,
        organizationRole: `Organization Role`,
        systemRole: `System Role`,
        resetPassword: `Reset Password`,
        selectFile: `Select File`,
        chooseFile: `Choose File`,
        noFileChosen: `No file chosen`,
        downloadSampleFile: `Download Sample File`,
        fileSelectionError: `No file selected. Please select the valid Excel or CSV file`,
        confirmMessage: `Confirm Message`,
        userDeactivateConfirmationMsg: `If you proceed with deactivating this user's status, they will be permanently removed from any teams. This action cannot be undone.`,
        selectSystemRole: `Select System Role`,
        systemRoleIsRequired: `System Role is required`,
        sendPassword: `Send Password`,
        sendPasswordConfirmMsg: `Are you sure want to send the password?`,
        send: `Send`,
        deleteMemberConfirmationMsg: `Are you sure want to delete this member`,
        importMembersErrorMsg: `Some members could not be imported. Please review and correct the Excel data, then retry.`,
        noneImportMembersErrorMsg: `None members were imported. Please review and correct the Excel data, then retry.`,
        maximumFileSize: `Maximum file size: 50 MB`,
        confirmContinue: `Are you sure you want to continue?`,
        fileSizeError: `File size exceeds 50 MB. Please upload a smaller file.`,
        fileInvalidError: `Invalid file format. Please upload an Excel or CSV file.`,
        zeroimportData: `None members were imported.`,
        downloadFile: `Download file`,
    },
    profileLabels: {
        profile: `Profile`,
        changePassword: `Change Password`,
        userId: `User ID`,
        organization: `Organization Name`,
        organizationRole: `Organization Role`,
        enterName: `Enter Name`,
        enterEmail: `Enter Email`,
        enterOrganization: `Enter Organization`,
        enterOrganizationRole: `Enter Organization Role`,
        enterAddress: `Enter Address`,
        nameIsRequired: `Name is required`,
        phoneIsRequired: `Phone is required`,
        userSavedImageNotSaved: `User saved successfully, Image not uploaded!`,
    },
    changePasswordLabels: {
        currentPassword: `Current Password`,
        currentPasswordIsRequired: `Current Password is required`,
        enterCurrentPassword: `Enter Current Password`,
        newPassword: `New Password`,
        passwordIsRequired: `Password is required`,
        enterNewPassword: `Enter New Password`,
        confirmNewPassword: `Confirm New Password`,
        enterConfirmNewPassword: `Enter Confirm New Password`,
        passwordUpercaseError: `Password must contain at least one uppercase letter.`,
        passwordLowercaseError: `Password must contain at least one lowercase letter.`,
        confirmPasswordIsRequired: `Confirm Password is required.`,
        passwordNotMatchError: `Confirm Password does not match with New Password`,
        passwordRequirements: `Password Requirements`,
        atLeast8charactersLong: `At least 8 characters long`,
        atLeast1Uppercase: `Must include one uppercase letter (A-Z)`,
        atLeast1Lowercase: `Must include one lowercase letter (a-z)`,
        atLeast1Number: `Must include one number (0-9)`,
        atLeast1SpecialCharacter: `Must include one special character (! @ # $ % ^ & * ( ))`,
    },
    forgotPasswordLabels: {
        forgotYourPassword: `Forgot your password?`,
        emailAddress: `Email Address`,
        enterEmailAddress: `Enter Email Address`,
        emailIsRequired: `Email is required`,
    },
    createProgramLabels: {
        createNewProgram: `Create New Programme`,
        allowOnlyFiles: `Allow only .jpg or .png file`,
        nameOfProgram: `Name of the programme`,
        enterProgramName: `Enter the programme name`,
        nameIsRequired: `Name is required`,
        programDescription: `Description of the programme`,
        showOnCatelogueCards: `This text will only show on the catalogue cards`,
        uploadCoverPhoto: `Upload Cover Photo`,
        addOwners: `Add Owners`,
        dragFile: `Drag a file or`,
        clickSelect: `click select`,
        fileSelectionPlaceholder: `to upload files you wish to use during the creation of your programme.`,
        editProgram: `Edit Programme`,
        fileSizeLimit20MB: `exceeds the 20 MB size limit.`,
        fileAlreadyUploaded: `is already uploaded.`,
        ownerRequiredMsg: `At least one owner is required.`,
        fileSizeLimit5MB: `Cover photo exceeds the 20 MB size limit.`,
        coverPhoto: `Cover Photo`,
        selectOwner: `Select Owners`,
        allowOnly: `Allow only`,
        deleteImgConfirmation: `Are you sure want to delete Image?`,
        allowFiles: `files.`,
        allowUpto: `Can upload maximum of 25 files. Each file size limits 20MB size.`,
        fileLimit: `You can upload a maximum of 25 files.`,
        uploadFailed: `Files not uploaded`,
        loading: `loading...`,
    },
    configureProgramLabels: {
        knowledgeGoalsPara1: `Knowledge goals define the essential knowledge, skills, and competencies that a learner should acquire upon completing the program. These goals ensure that all courses within the program contribute to a well-rounded learning outcome.`,
        knowledgeGoalsPara2: `Since a program consists of multiple courses, it's important to establish knowledge goals that encompass the entire curriculum. This helps maintain consistency and ensures learners achieve the intended proficiency.`,
        targetAudiencePara1: `The <b>target audience</b> refers to the specific group of learners for whom an eLearning program is designed. Identifying the target audience helps ensure that the content, language, and structure of the course are appropriate for their needs, prior knowledge, and learning goals.`,
        targetAudiencePara2: ``,
        prerequisitePara1: `<b>Prerequisite</b> knowledge refers to the foundational skills, concepts, or experiences that learners should have before starting a course or program. Establishing prerequisites ensures that learners can effectively engage with the material without unnecessary confusion or gaps in understanding.`,
        prerequisitePara2: ``,
        trainingObjectivesPara1: `<b>Training Objectives</b> define the specific skills, knowledge, or competencies that learners should acquire by the end of a course or training program. They serve as clear, measurable goals that guide both instructional design and learner progress, ensuring that training is focused and outcome-driven.`,
        trainingObjectivesPara2: `It will aid to Design assessments that accurately measure learning outcomes and provide learners with a clear path to acquiring and applying new knowledge. While knowledge goals define what learners should ultimately know, training objectives specify how they will get there, ensuring a structured and effective learning experience.`,
        useCasesPara1: `The <b>subject</b> defines the main topic or area of focus for a course or training program. It establishes the foundation for learning, ensuring that all content, activities, and assessments align with a central theme. A well-defined subject keeps the course structured, relevant, and engaging, helping learners stay focused and ensuring coherence throughout the program.`,
        useCasesPara2: `<b>Use cases</b> describe the real-world applications or scenarios in which the course content will be applied. They help instructional designers tailor materials, examples, and activities to match learners’ work environments, industries, or specific learning needs.`,
        ekcMatrixPara1: `The <b>EKC Matrix</b> is a structured framework that organizes subjects and use cases into a table, allowing course creators to define the level of learning required at each intersection. By categorizing learning objectives into different levels, the EKC Matrix ensures a clear progression of knowledge and skill development throughout a course or program.`,
        ekcMatrixPara2: `The matrix consists of three learning levels: <br> <b>Level 1 – Understand:</b> Learners should gain foundational knowledge, enabling them to comprehend the subject in a specific use case. This level focuses on awareness and conceptual understanding. <br> <b>Level 2 – Apply:</b> Learners should be able to use the acquired knowledge to solve problems or perform tasks related to the subject in a specific use case. This level emphasizes practical application.<br> <b>Level 3 – Create:</b> Learners should be able to generate new ideas, solutions, or content based on the knowledge gained from the course. This level focuses on innovation and mastery.`,
        contentDescriptionPara1: `<b>Content description</b> outlines the specific materials, topics, and learning resources included in a course or training program. It provides an overview of what learners will engage with, ensuring that the course structure is clear, organized, and aligned with learning objectives.`,
        contentDescriptionPara2: `Think of this as your free flow of ideas for the course. This is where you map out everything you want to cover, from key concepts and instructional materials to interactive elements and assessments. It’s your creative space to brainstorm how to best present the subject matter.`,
        assistCourseInitiatePara1: `Based on your input on the previous pages we can now create your course outline.`,
        assistCourseInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistCourseConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistCoursePromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Course outline.`,
        assistEditCourseInitiatePara1: `Based on your input on the previous pages we can now create your course data.`,
        assistEditCourseInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditCourseConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditCoursePromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Course data.`,
        assistLessonInitiatePara1: `Based on your input on the previous pages we can now create your lesson outline.`,
        assistLessonInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistLessonConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistLessonPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Lesson outline.`,
        assistEditLessonInitiatePara1: `Based on your input on the previous pages we can now create your lesson data.`,
        assistEditLessonInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditLessonConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditLessonPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Lesson data.`,
        assistChapterInitiatePara1: `Based on your input on the previous pages we can now create your chapter outline.`,
        assistChapterInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistChapterConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistChapterPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Chapter outline.`,
        assistEditChapterInitiatePara1: `Based on your input on the previous pages we can now create your chapter data.`,
        assistEditChapterInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditChapterConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditChapterPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Chapter data.`,
        assistSectionInitiatePara1: `Based on your input on the previous pages we can now create your section outline.`,
        assistSectionInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistSectionConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistSectionPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Section outline.`,
        assistEditSectionInitiatePara1: `Based on your input on the previous pages we can now create your section data.`,
        assistEditSectionInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditSectionConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditSectionPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Section data.`,
        updateAiCourseConfirmation: `This action will replace the your course outline data of the {{versionName}} with AI response for course outline.`,
        updateAiLessonConfirmation: `This action will replace the your lesson outline data of the {{versionName}} with AI response for lesson outline.`,
        updateAiChapterConfirmation: `This action will replace the your chapter outline data of the {{versionName}} with AI response for chapter outline.`,
        updateAiSectionConfirmation: `This action will replace the your section outline data of the {{versionName}} with AI response for section outline.`,
        addAiCourseConfirmation: `This action will add the AI generated course outline data into the {{versionName}}.`,
        addAiLessonConfirmation: `This action will add the AI generated lesson outline data into the {{versionName}}.`,
        addAiChapterConfirmation: `This action will add the AI generated chapter outline data into the {{versionName}}.`,
        addAiSectionConfirmation: `This action will add the AI generated section outline data into the {{versionName}}.`,
        dontKnow: `Don't know`,
        whereToStart: `where to start?`,
        eduscriptAssist: `Eduscript assist`,
    },
    knowledgeBankLabels: {
        searchInputPlaceholder: `Search by Name, Type, Uploader`,
        createdBetween: `Created Between`,
        groupBy: `Group By`,
        program: `Program`,
        documentType: `Document Type`,
        creator: `Creator`,
        uploadFile: `Upload File`,
        totalFilesInAllProgram: `Total Files in all Program`,
        maxFileLimit: `File size should be less than 20MB`,
        size: `Size`,
        name: `Name`,
        mediaType: `Media Type`,
        createdBy: `Created By`,
        uploadedAt: `Uploaded At`,
        action: `action`,
        replaceData: `Replace Data`,
        downloadData: `Download Data`,
        selectProgram: `Select Programme`,
        browseAndUploadFile: `Browse and Upload File`,
        chooseFile: `Choose file`,
        noFileChosen: `No file chosen`,
        fileCaptured: `File Captured`,
        deleteMediaConfirmationMsg: `Are you sure want to Delete this Media`,
        upload: `Upload`,
        cancel: `Cancel`,
        loading: `loading...`,
        selectDateRange: `Select Date Range`,
        fileLimit: `You can upload a maximum of 25 files in each program.`,
    },
    overviewLabels: {
        viewProgram: `View Summary Program`,
        program: `Programme`,
        selectProgram: `Select Programme`,
        noResultFound: `No result found`,
        addCourse: `Add Course`,
        exportProgram: `Export`,
        fundamental: `Fundamental`,
        comment: `Comment`,
        loading: `loading...`,
        noCourseAvailable: `No Course Available`,
        pleaseSelectProgram: `Please select Programme`,
        courseDeleteConfirmation1: `Are you sure you want to remove this course`,
        courseDeleteConfirmation2: `This action will permanently delete the course and all associated Lessons, Chapters, and Sections. This action cannot be undone.`,
        lessonDeleteConfirmation1: `Are you sure you want to remove this lesson`,
        lessonDeleteConfirmation2: `This action will permanently delete the lesson and all associated Chapters and Sections. This action cannot be undone.`,
        chapterDeleteConfirmation1: `Are you sure you want to remove this chapter`,
        chapterDeleteConfirmation2: `This action will permanently delete the chapter and all associated Sections. This action cannot be undone.`,
        sectionDeleteConfirmation1: `Are you sure you want to remove this section`,
        sectionDeleteConfirmation2: `This action will permanently delete the Sections. This action cannot be undone.`,
        chapterValidation: `Chapter not moved to another chapter`,
        sectionValidation: `Section not moved to another section`,
        withinCourseValidation: `Reordering is allowed only within the same Course.`,
        informationShow: `Reordering is allowed only within the same Course. Sections can be moved between Chapters, and Chapters can be moved between Lessons. However, items cannot change levels—Sections cannot become Chapters, and Chapters cannot become Lessons`,
        withinChapterValidation: `Section not moved to another lesson`,
        sectionwithChapterValidation: `Section not moved to another chapter`,
        noSectionFound: `No Section Found!`,
        noPermissionToAddComment: `There are no comments present in the section and you don't have permission to add any comment.`,
    },
    ekcMatrixLabels: {
        addSubjects: `Add Subjects`,
        addUsecases: `Add Usecases`,
        usecaseError: `At least one subject and one use case are required if any is added!`,
        understand: `Understand`,
        apply: `Apply`,
        editUsecases: `Edit Usecases`,
        noData: `No data`,
        noDataMsg: `Please create subjects and use cases to continue`,
    },
    courseLabels: {
        courseOutline: `Course outline`,
        courseTitle: `Course Title`,
        enterCourseTitle: `Enter Course Title`,
        courseDescription: `Course Description`,
        enterCourseDescription: `Enter Course Description`,
        manageTeamAndMembers: `Manage Team & Members`,
        assignTeamAndMembers: `Assign Team & Member`,
        assignTeams: `Assign Teams`,
        assignedTeams: `Assigned Teams`,
        assignedMembers: `Assigned Members`,
        selectMemberAndRole: `Select member and role`,
        memberName: `Member Name`,
        selectTeam: `Select Team`,
        courseTitleRequired: `Course Title is required.`,
        courseDescriptionLimitError: `Course Description has to be maximum 4000 characters`,
        wantToContinue: `Do you wanna continue?`,
        continueConfirmation: `You are about to save this programme's basic information and moving forward towards creating courses. In order to ensure a proper setup for the rest of this programme please makes sure that all Basic information have been filled in.`,
        newCourse: `New Course`,
        removeCourse: `Remove Course`,
    },
    lessonLabels: {
        lessonTitle: `Lesson Title`,
        enterLessonTitle: `Enter Lesson Title`,
        lessonDescription: `Lesson Description`,
        enterLessonDescription: `Enter Lesson Description`,
        newLesson: `New Lesson`,
        removeLesson: `Remove Lesson`,
    },
    chapterLabels: {
        chapterTitle: `Chapter Title`,
        enterChapterTitle: `Enter Chapter Title`,
        chapterDescription: `Chapter Description`,
        enterChapterDescription: `Enter Chapter Description`,
        newChapter: `New Chapter`,
        removeChapter: `Remove Chapter`,
    },
    sectionLabels: {
        sectionTitle: `Section Headline`,
        enterSectionTitle: `Enter Section Headline`,
        sectionDescription: `Section Storyboard`,
        enterSectionDescription: `Enter Section Storyboard`,
        newSection: `New Section`,
        removeSection: `Remove Section`,
        deleteMessage: `Are you sure you want to delete this section? This action cannot be undone.`,
        scriptPlaceholder: `Type or paste your script here...`,
        scriptWriting: `Script Writing`,
        scriptSegmenting: `Script Segmenting`,
        allowOnly: `Allow only`,
        allowUpto: `Can upload maximum of 25 files. Each file size limits 20MB size.`,
        fileLimit: `You can upload a maximum of 25 files.`,
        mediaUpload: `Media File Upload`,
        fileAlreadyUploaded: `is already uploaded.`,
        deleteSectionConfirmationMessage: `Are you sure you want to remove this segment?`,
        sectionScript: `Section Script`,
        downloadData: `Download Data`,
        scriptAiAssistInitiatePara1: `Based on your input on the previous pages we can now create your script data.`,
        scriptAiAssistInitiatePara2: `You can ask Eduscript assist to help you.`,
        scriptAiAssistConfirmationPara1: `Hi, would you like some help to create data?`,
        scriptAiAssistPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Script data.`,
        assist: ` Eduscript Assist`,
        uploadMedia: `Upload Media`,
        typehere: `Type Note here...`,
        fileSizeLimit20MB: `Cover photo exceeds the 20 MB size limit.`,
        uploadFailed: `Files not uploaded`,
        dragFile: `Drag a file or`,
        clickSelect: `click select`,
        fileSelectionPlaceholder: `to upload files you wish to use during the creation of your programme.`,
        allowFiles: `files.`,
        updateScriptConfirmationMessage: `Are you sure you want to update the script of "{{sectionName}}" section?`,
        deleteData: `Delete Data`,
        removeData: `Remove Data`,
        fileSizeLimit: `File exceeds the 20 MB size limit.`,
    },
    roleLabels: {
        listOfRoles: `List of Roles`,
        addNew: `Add New`,
        searchInputPlaceholder: `Role name or description`,
        roleName: `Role Name`,
        updateDate: `Update Date`,
        deleteRoleConfirmation: `Are you sure you want to delete this role?`,
        deactivateRoleConfirmation: `If you want to deactivate the status of this role, please ensure that all users assigned to this role are reassigned to a different role first. Users must not be left without a role before deactivation.`,
    },
    productionDashboardLabels: {
        program: `Programme`,
        selectProgram: `Select Programme`,
        cancel: `Cancel`,
        selectCourses: `Select Courses`,
        selectLessons: `Select Lessons`,
        selectChapters: `Select Chapters`,
        selectSections: `Select Sections`,
        section: `Section`,
        filterPresentations: `Filter Presentations`,
        exportAsExcel: `Export as excel`,
        applyFilters: `Apply Filters`,
        scriptOrSequenceOfEvent: `Script/Sequence of Events`,
        presentations: `Presentations`,
        presentation: `Presentation`,
        resourcesCount: `Resources count`,
        directionalNotes: `Directional Notes`,
        resources: `Resources`,
        productionMoments: `Production Moments`,
        clearFilters: `Clear Filters`,
        noData: `No Data Available`,
        loading: `Loading...`,
        atLeastOneSectionRequired: `Please select atleast one section to continue!`,
        pieChartTitle: `Presentation Type of Distribution`,
    },
    commentLabels: {
        comments: `Comments`,
        sectionName: `Section Name`,
        sectionHeadline: `Section Headline`,
        viewLess: `View Less`,
        viewMore: `View More`,
        noCommentsAvailable: `No Comments available`,
        selectSection: `Select Section`,
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        by: 'By',
        pleaseSelectSection: `Please select Section`,
        deleteCommentConfirmation: `Are you sure you want to delete this comment?`,
        acceptCommentConfirmation: `Are you sure you want to accept this comment?`,
        rejectCommentConfirmation: `Are you sure you want to reject this comment?`,
        discardCommentConfirmation: `Are you sure you want to discard this comment?`,
    },
} as const;
